import React, {useCallback, useMemo} from "react";
import "./index.scss";
import {object} from "prop-types";
import {Icon} from "features/components/icon";
import Title from "features/components/title";
import {__} from "services/i18n";
import moment, {ISO_8601} from "moment";
import {HOURS_TO_CONSIDER_NEW} from "constants.js";
import Text from "features/components/text";
import {historyObject} from "historyObject";
import {CategoryTagBox} from "features/components/category-tag-box";

export const DirectoryCard = (props) => {
    const {directory} = props;


    const isNew = useMemo(() => {
        return moment().diff(moment(directory.created_at, ISO_8601), 'hours') < HOURS_TO_CONSIDER_NEW;
    }, [directory]);

    const goToDetail = useCallback(() => {
        historyObject.push(`/directory/${directory.id}`);
    }, [directory.id]);

    return <div className="directory-card" onClick={goToDetail}>
        <img src={directory.image} alt={"directory front"}/>
        <div className="directory-content">
            <Icon>dashboard</Icon>
            <div className="data">
                <CategoryTagBox trim={true} categories={directory.categories} tags={[]}/>
                <Title size={20}>{directory.name}</Title>
                <Text size={16}>{__("common.directory.data", [{key: "[count]", value: directory.video_number}, {key: "[duration]", value: directory.total_duration}])}</Text>
            </div>
        </div>
        <div className="flags">
            {directory.requires_payment && <div className="paid">
                <Icon>lock</Icon>
                <Title size={14}>€ {directory.cost}</Title>
            </div>}
            {isNew && <div className="new">
                <Title size={14}>{__("common.new")}</Title>
            </div>}
        </div>
    </div>
};
DirectoryCard.propTypes = {
    directory: object.isRequired
}